import tw, { styled } from "twin.macro";

export const Grid = styled.div`
  ${tw`grid gap-8 gap-x-24 grid-cols-1 md:grid-cols-2`}
  label:has(textarea) {
    ${tw`col-span-2 mt-4`}
  }
`;
